//#region components/emoji_picker/emoji_picker_constants.js
var e = {
	ARROW_UP: "ArrowUp",
	ARROW_DOWN: "ArrowDown",
	ARROW_LEFT: "ArrowLeft",
	ARROW_RIGHT: "ArrowRight"
}, t = "https://static.dialpadcdn.com/joypixels/png/unicode/32/", n = 9, r = {
	DEFAULT: "Default",
	LIGHT: "Light",
	MEDIUM_LIGHT: "MediumLight",
	MEDIUM: "Medium",
	MEDIUM_DARK: "MediumDark",
	DARK: "Dark"
}, i = { EMOJI_PICKER_SKIN_TONE_MODIFIERS: r };
//#endregion
export { e as ARROW_KEYS, t as CDN_URL, n as EMOJIS_PER_ROW, r as EMOJI_PICKER_SKIN_TONE_MODIFIERS, i as default };

//# sourceMappingURL=emoji-picker-constants.js.map